import { render, staticRenderFns } from "./AssociationRedefiner.vue?vue&type=template&id=6f95ef51&scoped=true&"
import script from "./AssociationRedefiner.vue?vue&type=script&lang=ts&"
export * from "./AssociationRedefiner.vue?vue&type=script&lang=ts&"
import style0 from "./AssociationRedefiner.vue?vue&type=style&index=0&id=6f95ef51&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f95ef51",
  null
  
)

export default component.exports